;
(function ($) {
  var dataKey = 'app.debts';
  var Debts = function Debts(element, options) {
    this.grandTotal;
    this.element = element;
    this.init(options);
  };
  Debts.prototype = {
    settings: {
      currency: '£',
      maximumDebtRows: 10,
      totalIncome: 'TotalIncome',
      totalOutgoings: 'TotalOutgoings',
      totalPriorityCreditors: 'TotalPriorityCreditors'
    },
    attr: {
      container: 'data-debts-table',
      debtsContainer: 'data-debts-container',
      group: 'data-debts-group',
      groupTotal: 'data-debts-grouptotal',
      subTotal: 'data-debts-subTotal',
      grandTotal: 'data-debts-grandtotal',
      priorityTotal: 'data-debts-priority',
      message: 'data-debts-message',
      add: 'data-debts-add',
      remove: 'data-debts-remove',
      groupInput: 'data-debts-input'
    },
    classes: {
      hidden: 'hidden',
      danger: 'danger',
      disabled: 'disabled',
      grandTotal: 'grand-total'
    },
    /**
     * Initialise Debts
     * Initialises the debts plugin
     * @public
     * @constructor
     * @param {string} options - Apply and extend options into init if needed.
     */

    init: function init(options) {
      $.extend(this.options, options);
      var _this = this;
      this.getGrandTotal();
      $('[' + this.attr.group + ']').on('change', function () {
        var type = $(this).attr(_this.attr.group);
        _this.setGroupTotal(type);
      });
      $('[' + this.attr.add + ']').on('click', function (e) {
        e.preventDefault();
        _this.onAddDebtRow(e);
        $(this).hide();
      });
      $('[' + this.attr.remove + ']').on('click', function (e) {
        e.preventDefault();
        _this.onRemoveDebtRow(e);
      });
    },
    /**
     * Add New Debt Row
     * Adds a new debt row to the data-debts table.
     * @private
     * @param {event} e - event of the targetted button.
     */

    onAddDebtRow: function onAddDebtRow(e) {
      var _this = this;
      var container = $(e.currentTarget).parents('[' + this.attr.debtsContainer + ']');
      var table = container.find('[' + this.attr.container + ']');
      var debts = table.find('tr:not(.' + this.classes.hidden + ')');
      var type = $(e.currentTarget).attr(this.attr.add);
      var add = container.find('[' + this.attr.add + ']');
      var remove = container.find('[' + this.attr.remove + ']');
      if (debts.length < this.settings.maximumDebtRows) {
        var debt = debts.last().next('tr');
        debts.length++;
        debt.removeClass(this.classes.hidden);
        debt.show();
      }
      if (debts.length === this.settings.maximumDebtRows) {
        add.each(function (i) {
          $(this).addClass(_this.classes.disabled);
          $(this).prop('disabled', true);
        });
      }
      if (debts.length > 1) {
        remove.show();
      }
    },
    /**
     * Remove Last Debt Row
     * Removes the last debt row from the data-debts table.
     * @private
     * @param {event} e - event of the targetted button.
     */

    onRemoveDebtRow: function onRemoveDebtRow(e) {
      var container = $(e.currentTarget).parents('[' + this.attr.debtsContainer + ']');
      var table = container.find('[' + this.attr.container + ']');
      var debts = table.find('tr:not(.' + this.classes.hidden + ')');
      var add = $('[' + this.attr.add + ']');
      var remove = $(e.currentTarget);
      if (debts.length > 1) {
        var debt = debts.last();
        debts.length--;
        debt.addClass(this.classes.hidden);
        debt.find('input').each(function (i) {
          $(this).val('');
        });
        this.setGroupTotal();
      }
      if (debts.length === 1) {
        remove.hide();
      }
      if (debts.length < this.settings.maximumDebtRows) {
        add.removeClass(this.classes.disabled);
        add.prop('disabled', false);
      }
    },
    /**
     * Get Group Total
     * Adds and returns all the values of the specified group type.
     * @private
     * @param {string} type - the debt group type.
     */

    getGroupTotal: function getGroupTotal(type) {
      var _this = this;
      var total = 0;
      $('[' + this.attr.group + '="' + type + '"]').each(function () {
        var val = parseFloat($(this).val().replace(',', ''));
        if (!isNaN(val)) {
          total = total + val;
        }
      });
      return total;
    },
    /**
     * Get Grand Total
     * Gets the grand total.
     * @private
     */

    getGrandTotal: function getGrandTotal() {
      var totalIncome = parseFloat($('[name="' + this.settings.totalIncome + '"]').val());
      var totalOutgoings = parseFloat($('[name="' + this.settings.totalOutgoings + '"]').val());
      var totalPriorityCreditors = parseFloat($('[name="' + this.settings.totalPriorityCreditors + '"]').val());
      this.grandTotal = totalIncome - totalOutgoings - totalPriorityCreditors;
    },
    /**
     * Set Group Total
     * Calculates and returns the total amount of all fields with a given type.
     * @public
     * @param {string} type - the debt type.
     */

    setGroupTotal: function setGroupTotal(type) {
      var _this = this;
      var groupTotal;
      var groupTotalValue;
      var otherDebtText = 'Apply Other Debts: ';
      if (type !== undefined) {
        var input = $('[' + this.attr.groupInput + '="' + type + '"]');
        groupTotal = $('[' + this.attr.groupTotal + '="' + type + '"]');
        groupTotalValue = this.getGroupTotal(type);
        groupTotal.html(otherDebtText + _this.settings.currency + $.number(groupTotalValue, 2));
        if (input) {
          input.val($.number(groupTotalValue, 2));
        }
        this.setSubTotal(type, groupTotalValue);
        if (type === 'payment') {
          this.setGrandTotal(groupTotalValue);
        }
      } else {
        var types = [];
        $('body').find('[' + this.attr.groupTotal + ']').each(function () {
          var type = $(this).attr(_this.attr.groupTotal);
          types.push(type);
        });
        types.forEach(function (type, index) {
          groupTotal = $('[' + _this.attr.groupTotal + '="' + type + '"]');
          groupTotalValue = _this.getGroupTotal(type);
          groupTotal.html(otherDebtText + _this.settings.currency + $.number(groupTotalValue, 2));
          _this.setSubTotal(type, groupTotalValue);
          if (type === 'payment') {
            _this.setGrandTotal(groupTotalValue);
          }
        });
      }
    },
    /**
     * Set Sub Total
     * Calculates and returns the sub total of a given debt type.
     * @private
     * @param {string} type - the debt type.
     * @param {string} groupValue - the total value of the group.
     */

    setSubTotal: function setSubTotal(type, groupValue) {
      var priorityTotal = $('[' + this.attr.priorityTotal + '="' + type + '"]');
      var priorityTotalValue = priorityTotal.val();
      var subTotal = $('[' + this.attr.subTotal + '="' + type + '"]');
      var subTotalValue = priorityTotalValue + groupValue;
      subTotal.html(this.settings.currency + $.number(subTotalValue, 2));
    },
    /**
     * Set Grand Total
     * Calculates and sets the grand total
     * @private
     * @param {string} total - the sub total.
     */

    setGrandTotal: function setGrandTotal(total) {
      var grandTotal = $('[' + this.attr.grandTotal + ']');
      var grandTotalValue = this.grandTotal - total;
      var message = $('[' + this.attr.message + ']');
      var otherDebtText = 'Apply Other Debts: ';
      grandTotal.html(otherDebtText + this.settings.currency + $.number(grandTotalValue, 2));
      if (grandTotalValue <= 0) {
        grandTotal.parents('.' + this.classes.grandTotal).addClass(this.classes.danger);
        message.removeClass(this.classes.hidden);
      } else {
        grandTotal.parents('.' + this.classes.grandTotal).removeClass(this.classes.danger);
        message.addClass(this.classes.total);
      }
    }
  };

  /**
   * Global callback function which by default all [data-debts] triggers this plugin.
   * @method $.fn.app_debts()
   * @public
   * @constructor
   * @param {string} options
   * @optional options
   * @example $(element).app_debts();
   */

  $.fn.app_debts = function (options) {
    var plugin = this.data(dataKey);
    if (plugin instanceof Debts) {
      if (typeof options !== 'undefined') {
        plugin.init(options);
      }
    } else {
      plugin = new Debts(this, options);
      this.data(dataKey, plugin);
    }
    return plugin;
  };
})(jQuery, window, document);